import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type BeneficiariesType = 'envio' | 'boleto' | 'titularidade';

export interface BeneficiariesState {
  type: BeneficiariesType;
}

const initialState: BeneficiariesState = {
  type: 'envio',
};

const beneficiariesSlice = createSlice({
  name: 'beneficiaries',
  initialState,
  reducers: {
    setType: (state: BeneficiariesState, action: PayloadAction<BeneficiariesType>) => {
      state.type = action.payload;
    },
  },
});

export const { setType } = beneficiariesSlice.actions;
export default beneficiariesSlice.reducer;
